export const TRAY_BRAND = {
  primaryColor: '#00a0dc'
}

export const TRAY_HOSTNAMES = [
  'tray',
  'erp.tray.com.br',
  'staging.connectplug.com.br'
]
